<template>
  <div class="trace-config">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="关键控制点" name="first">
        <ControlPoint />
      </el-tab-pane>
      <el-tab-pane label="检验项" name="second">
        <CheckItems />
      </el-tab-pane>
      <el-tab-pane label="溯源模板" name="third">
        <TraceTemplate />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ControlPoint from './components/ControlPoint'
import CheckItems from './components/CheckItems'
import TraceTemplate from './components/TraceTemplate'
export default {
  components: {
    ControlPoint,
    CheckItems,
    TraceTemplate
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  methods: { }
}
</script>
<style lang="scss" scoped>
.trace-config{
  padding: 0px;
}
</style>
